/* ==========================================================================
   ZWANZE — facets.js
   Filtres et tri sans rechargement, via la Section Rendering API.
   Sans JavaScript, le formulaire se soumet normalement : rien n'est perdu.
   ========================================================================== */
(function () {
  'use strict';
  const Z = window.Zwanze;
  if (!Z) return;

  class Facets extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-facets-form]');
      this.sort = this.querySelector('[data-facets-sort]');
      this._debounce = null;

      this.querySelectorAll('[data-facets-open]').forEach((btn) =>
        btn.addEventListener('click', () => this._toggle(true)));
      this.querySelectorAll('[data-facets-close]').forEach((btn) =>
        btn.addEventListener('click', () => this._toggle(false)));

      if (this.form) {
        this.form.addEventListener('change', () => this._schedule());
        this.form.addEventListener('submit', (event) => { event.preventDefault(); this._apply(); });
      }
      if (this.sort) this.sort.addEventListener('change', () => this._apply());

      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-facets-link]');
        if (!link) return;
        event.preventDefault();
        this._render(link.href);
      });

      window.addEventListener('popstate', () => this._render(window.location.href, false));
    }

    _toggle(open) {
      this.toggleAttribute('data-open', open);
      Z.lockScroll(open && window.innerWidth < 990);
      const trigger = this.querySelector('[data-facets-open]');
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
    }

    _schedule() {
      window.clearTimeout(this._debounce);
      this._debounce = window.setTimeout(() => this._apply(), 320);
    }

    _apply() {
      const params = new URLSearchParams();
      if (this.form) {
        new FormData(this.form).forEach((value, key) => {
          if (value !== '') params.append(key, value);
        });
      }
      if (this.sort && this.sort.value) params.set('sort_by', this.sort.value);
      const url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      this._render(url);
    }

    async _render(url, push) {
      this.setAttribute('aria-busy', 'true');
      try {
        const doc = await Z.fetchSection(url, this.dataset.section);
        ['[data-facets-grid]', '[data-facets-form]', '[data-facets-count]'].forEach((selector) => {
          const fresh = doc.querySelector(selector);
          const current = this.querySelector(selector);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        const pagination = doc.querySelector('.z-pagination');
        const currentPagination = this.querySelector('.z-pagination');
        if (currentPagination) currentPagination.replaceWith(pagination || document.createComment(''));

        if (push !== false) window.history.pushState({}, '', url);

        const count = this.querySelector('[data-facets-count]');
        if (count) Z.announce(count.textContent.trim());
      } catch (error) {
        window.location.href = url;
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('z-facets', Facets);
})();
